import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styles from './DocsIndex.module.css';

const ADMIN_GUIDES = [
  {
    title: 'SSO Admin Guide',
    description:
      'Configure Single Sign-On for your organization with SAML 2.0 or OpenID Connect. Requires SSO to be enabled by a KNOW administrator. Includes step-by-step guides for Azure AD, Okta, and Google Workspace.',
    path: '/docs/sso-admin-guide',
    icon: '🔐',
  },
];

const USER_GUIDES = [];

function DocCard({ doc }) {
  return (
    <Link to={doc.path} className={styles.card}>
      <span className={styles.cardIcon}>{doc.icon}</span>
      <div className={styles.cardBody}>
        <h3 className={styles.cardTitle}>{doc.title}</h3>
        <p className={styles.cardDesc}>{doc.description}</p>
      </div>
    </Link>
  );
}

DocCard.propTypes = {
  doc: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
  }).isRequired,
};

export default function DocsIndex() {
  useEffect(() => {
    document.title = 'KNOW - Documentation';
  }, []);

  return (
    <div className={styles.docsIndexContainer}>
      <h1 className={styles.heading}>Documentation</h1>
      <p className={styles.subtitle}>Guides and references for using KNOW Oncology.</p>

      <section className={styles.categorySection}>
        <h2 className={styles.categoryTitle}>Admin Guides</h2>
        <div className={styles.cardGrid}>
          {ADMIN_GUIDES.map((doc) => (
            <DocCard key={doc.path} doc={doc} />
          ))}
        </div>
      </section>

      <section className={styles.categorySection}>
        <h2 className={styles.categoryTitle}>User Guides</h2>
        {USER_GUIDES.length > 0 ? (
          <div className={styles.cardGrid}>
            {USER_GUIDES.map((doc) => (
              <DocCard key={doc.path} doc={doc} />
            ))}
          </div>
        ) : (
          <p className={styles.emptyState}>More guides coming soon.</p>
        )}
      </section>
    </div>
  );
}
